import { Action } from 'redux';
import { put, select } from '@redux-saga/core/effects';

import { routes } from 'routes';
import { AppState } from 'store';
import { BasketSagaReturnType, callBasketSaga } from 'store/sagaHelpers';
import { preprocessRedirectToNextStepSaga } from './preprocessRedirectToNextStep';
import { BasketActionTypes } from 'store/basket';
import { CheckoutActions, CheckoutActionTypes } from 'store/checkout';
import { validateBasketReservationsSaga } from 'store/basket/actions';
import { ACTION_CREATOR_NAME, paymentHelper, GtmCheckoutSteps, ExponeaCheckoutSteps } from 'helpers';

export interface PreprocessContinueDeliveryDateAction extends Action<CheckoutActionTypes.CONTINUE_FROM_DELIVERY_DATE> {
    redirectFunc: (route: string) => void;
}

export interface PreprocessContinueDeliveryDateActionStart extends Action<CheckoutActionTypes.CONTINUE_FROM_DELIVERY_DATE_START> {
}

export interface PreprocessContinueDeliveryDateActionSuccess extends Action<CheckoutActionTypes.CONTINUE_FROM_DELIVERY_DATE_SUCCESS> {
}

export interface PreprocessContinueDeliveryDateActionError extends Action<CheckoutActionTypes.CONTINUE_FROM_DELIVERY_DATE_ERROR> {
}

export const preprocessContinueDeliveryDate: (redirectFunc: () => void) => PreprocessContinueDeliveryDateAction = (redirectFunc: () => void) => ({
    type: CheckoutActionTypes.CONTINUE_FROM_DELIVERY_DATE,
    redirectFunc
});
preprocessContinueDeliveryDate[ACTION_CREATOR_NAME] = 'preprocessContinueDeliveryDate';
export type PreprocessContinueDeliveryDateFunc = (...args: Parameters<typeof preprocessContinueDeliveryDate>) => void;

export function* preprocessContinueDeliveryDateSaga({ redirectFunc }: PreprocessContinueDeliveryDateAction): BasketSagaReturnType {
    try {
        yield put<CheckoutActions>({
            type: CheckoutActionTypes.CONTINUE_FROM_DELIVERY_DATE_START,
        });

        yield callBasketSaga(validateBasketReservationsSaga, {
            type: BasketActionTypes.VALIDATE_BASKET_RESERVATIONS,
            isBasketPage: false
        });

        const state: AppState = yield select();
        const { basket, shouldShowReservationWarning } = state.basketState;
        const { paymentDetails } = state.paymentState;

        const isValid = basket && !shouldShowReservationWarning;

        if (!isValid) {
            return true;
        }

        const route = paymentHelper.isCardRelatedPaymentType(paymentDetails.paymentType)
            ? routes.payment.path
            : routes.dataProtectionNotice.path;

        yield callBasketSaga(preprocessRedirectToNextStepSaga, {
            type: CheckoutActionTypes.PREPROCESS_REDIRECT_TO_NEXT_STEP,
            redirectFunc: () => redirectFunc(route),
            gtmStep: GtmCheckoutSteps.PaymentOrDpn,
            exponeaStep: ExponeaCheckoutSteps.DeliveryDate
        });

        yield put<CheckoutActions>({
            type: CheckoutActionTypes.CONTINUE_FROM_DELIVERY_DATE_SUCCESS,
        });

        return true;
    } catch (error) {
        yield put<CheckoutActions>({
            type: CheckoutActionTypes.CONTINUE_FROM_DELIVERY_DATE_ERROR,
        });

        return false;
    }
}